import { render, staticRenderFns } from "./form-inputA.vue?vue&type=template&id=87669de0&scoped=true&"
import script from "./form-inputA.vue?vue&type=script&lang=js&"
export * from "./form-inputA.vue?vue&type=script&lang=js&"
import style0 from "./form-inputA.vue?vue&type=style&index=0&id=87669de0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87669de0",
  null
  
)

export default component.exports